import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "sellers_payments";
// initial state
const state = () => ({
  all: [],
  sellerPayments: [],
  sellerPayment: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSellerPayment: (state) => {
    return state.sellerPayment;
  },

  getSellerPayments: (state) => {
    return state.sellerPayments;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let sellerPayments = response.data;
      commit("setSellerPayments", sellerPayments);
    });
  },
  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let sellerPayment = response.data;
      commit("setSellerPayment", sellerPayment);
    });
  },

  async destroy({ commit, dispatch }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        let sellerPayments = response.data.data;
        commit("setSellerPayments", sellerPayments);
      }
    });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({
          name: "seller-payments-index",
        });
      }
    });
  },

  async update({ dispatch }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;

        if (status == "success") {
          dispatch("notification/store", { status, message }, { root: true });
          router.push({
            name: "seller-payments-index",
          });
        }
      });
  },
};

// mutations
const mutations = {
  setSellerPayments(state, sellerPayments) {
    state.all = sellerPayments;
    state.sellerPayments = sellerPayments;
  },
  setSellerPayment(state, sellerPayment) {
    state.sellerPayment = sellerPayment;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.sellerPayments = state.all.filter(function (sellerPayment) {
      return (
        (sellerPayment.reference &&
          sellerPayment.reference.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerPayment.sellerSale &&
          sellerPayment.sellerSale.reference &&
          sellerPayment.sellerSale.reference
            .toUpperCase()
            .indexOf(value.toUpperCase()) > -1)
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
